export const ID_ACTIVE = 'ACTIVE';
export const ID_INACTIVE = 'INACTIVE';
export const ID_STANDARD = 'STANDARD';
export const ID_RETAIL_EXTRA = 'RETAIL_EXTRA';
export const ID_CORPORATE_EXTRA = 'CORPORATE_EXTRA';
export const ID_ANCILLARIES_EXTRA = 'ANCILLARIES_EXTRA';